// C:\Users\phill\paperplay\frontend\src\components\common\LogoDevAttribution.tsx

import React from 'react';

import { shouldShowLogoDevAttribution } from '../../utils/logoDev';

type LogoDevAttributionProps = {
  className?: string;
  style?: React.CSSProperties;
};

const LogoDevAttribution: React.FC<LogoDevAttributionProps> = ({ className, style }) => {
  if (!shouldShowLogoDevAttribution()) return null;

  return (
    <small className={className} style={style}>
      <a href="https://logo.dev" target="_blank" rel="noopener">
        Logos provided by Logo.dev
      </a>
    </small>
  );
};

export default LogoDevAttribution;

